import { useApi } from './use-api-call';
import { SmsStatusDTO } from './sms-status-api';
import { SmsTypeDTO } from './sms-type-api';
import { UserDTO } from './user-api';

export const useSearchSmsLogApi = () =>
    useApi<{
        smsLogs: SmsLogDTO[];
        smsStatuses: SmsStatusDTO[];
        smsTypes: SmsTypeDTO[];
        users: UserDTO[];
        allowEdit: boolean;
    }>('/sms-log/search-sms-log');

export const useGetSmsLogApi = () =>
    useApi<{ smsLog: SmsLogDTO; allowEdit: boolean }>('/sms-log/get-sms-log/{serial}');

export const useSaveSmsLogApi = () => useApi<{ smsLog: SmsLogDTO }>('/sms-log/save-sms-log');

export const useDeleteSmsLogApi = () => useApi('/sms-log/delete-sms-log/{serial}');

export interface SmsLogDTO {
    serial?: number;
    message: string;
    typeId: string;
    statusId: string;
    phoneNumber: string;
    userName: string;
    sentAt: Date;
}
